<template>
    <div class="d-flex flex-fill mt-2 mt-md-0">
        <button v-if="agotadas" class="button large-button red-content" disabled>
            {{ $t('partidos.agotadas') }}
        </button>
        <GoToCheckoutButton
            v-else-if="comprar"
            :title="$t('partidos.comprar')"
            :subtitle="$t('partidos.soy_abonado', { abonado: teatro.texto_abonado })"
            :route="ruta"
            :event_id="event.id"
            :sesion_id="event.sesion_id"
            tipo_venta="abonados"
        />
    </div>
</template>

<script>
    import GoToCheckoutButton from "@/components/frontend/events/show/GoToCheckoutButton";

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            esLfpSga: {
                type: Boolean
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            ruta() { 
                return this.event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados'; 
            },
            comprar() {
                if (this.esLfpSga) {
                    return true;
                }

                return this.event.entradas_disponibles_abonos?.length;
            },
            agotadas() {
                if (this.esLfpSga) {
                    return this.event.entradas_agotadas_online;
                }

                return this.event.entradas_agotadas_online || !this.event.entradas_disponibles_abonos?.length;
            }
        },
        components: {
            GoToCheckoutButton
        }
    }
</script>